<style lang="scss">
  @use "../../../assets/css/design-system/colors";

  .table-wrapper {
    height: 100%;
    overflow: auto;
    border: 1px solid colors.get(interfaceSwGrey_10);
    border-radius: 8px;

    table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
    }
  }
</style>

<script>
  import { setContext } from "svelte";
  import { createTableContext, TABLE_STORES } from "./table-context";

  const stores = createTableContext();
  setContext(TABLE_STORES, stores);
</script>

<div class="table-wrapper">
  <table>
    <slot />
  </table>
</div>
